import { Middleware } from 'redux';
import { create } from '@wix/fedops-logger';
import createFedopsLogger from './middleware/fedopsLogger';
import rootReducer from '../reducers/index';
import rootSaga from '../sagas';
import { AppState } from '../types/store';
import logger from '../helpers/logger';
import { rootModuleStoreFactory } from '@wix/da-shared-react/pkg/redux/rootModuleStore/factory';
import { IModuleStore } from 'redux-dynamic-modules-core';

export function configureStore(initialState: AppState): IModuleStore<AppState> {
  const middleware: Middleware[] = [];

  if (typeof window !== 'undefined') {
    const flogger = create('da-browse');
    (window as any).__FLOGGER__ = flogger;
    middleware.push(createFedopsLogger(flogger) as any);
  }

  return rootModuleStoreFactory<AppState>(
    middleware,
    logger,
    initialState,
    rootReducer,
    rootSaga,
    false
  ) as IModuleStore<AppState>;
}
